import {Component, Inject, Input} from 'ng-metadata/core';
import {NgrsService} from './ngrs.service';
import {JwtUtilService} from "../../../security/jwtUtil.service";



@Component({
    "selector": "prm-service-ngrs",
    templateUrl: 'components/search/fullView/ngrs/ngrs.html'
})

export class PrmServiceNgrs{
   
    @Input() item:Object;
    private _offerFound: Object; 
    private _display: Object;
    private _getItFormOpen: Object;
    private _bestOffer: {
        supplyTime:String,
        loanPeriod:String,
        cost:String,
        allowRenewal:boolean,
        supportRush:boolean,
        memberId:String,
        policyId:String,
        lenderMemberName:String,
        lenderMemberId:String,
        availableLenderMmsId: String,
        lenderInstitutionId: String
    };

    constructor (private ngrsService: NgrsService,
                 private jwtUtilService: JwtUtilService){
    }

    ngOnInit(){
        this._offerFound={offerFound:true};
        this._display={display:'display:none'};
        this._getItFormOpen={getItFormOpen:false};
        this._bestOffer={supplyTime:'0',
            loanPeriod:'0',
            cost:'0',
            allowRenewal:true,
            supportRush:false,
            memberId:'0L',
            policyId:'0L',
            lenderMemberName:'',
            lenderMemberId:'0L',
            availableLenderMmsId: '0L',
            lenderInstitutionId: '0L'
            };
    }

    public isSignedIn(){
        let isUser = this.jwtUtilService.getDecodedToken().userGroup;
        if (isUser === 'GUEST'){
            return false;
        }
        return true;
    }

    get signInLink(){
        return this.ngrsService.signInLink;
    }

    public offerFound(){
        return this._offerFound.offerFound;
    }

    public display(){
        return this._display.display;
    }

    public isShowBestOffer(): boolean {
        return !(this._getItFormOpen.getItFormOpen);
    }    

}








// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/ngrs.directive.ts